import React, { useRef, useState } from "react";
import { Box, StyledText } from "../../../components/common";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import {
  ChevronRightArrow,
  Copy,
  Curve,
  ExclamationSmall,
} from "../../../components/svgs";
import {
  Body,
  Children,
  CurveHolder,
  DynamicButton,
  MainHolder,
} from "../../../components/common/basic";

import { BackButton } from "../../../components/common";
import { format } from "date-fns";
import CheckCircleIcon from "../../../components/svgs/checkCircleIcon";
import BoxSwitch from "./components/boxSwitch";
import { useSubscriber } from "../../../hooks";
import useReferrals from "./hooks/useReferrals";

const roundToDecimalPlace = (value, decimalPlaces) => {
  let roundedValue = parseFloat(value?.toFixed(decimalPlaces));
  let valueString = roundedValue.toString();
  if (valueString.includes(".")) {
    valueString = valueString.replace(/\.?0+$/, "");
  }
  return valueString;
};

const ReferralHome = () => {
  const {
    isLoading,
    referralData,
    referralPoints,
    pointsEarned,
    receivedData,
    isOn,
    toggleSwitchState,
    history,
    redemptions,
    pointsData,
  } = useReferrals();

  // New Link - Date: 10-03-2025
  // https://mymtn.onelink.me/cB5t/PulseRefer

  return (
    <>
      <MainHolder style={{ background: "#F2F2F2" }}>
        <Children>
          <Header background={"#E31C79"}>
            <BackButton
              onClick={() => {
                history.push(
                  `/home?token=${JSON.parse(localStorage.getItem("token"))}`
                );
              }}
            />
            <div style={{ height: 65 }}></div>
            <div style={{ textAlign: "center", marginBottom: "30px" }}>
              <StyledText
                style={{ fontFamily: "MTNRegular" }}
                size={24}
                margin="0"
                color="white"
              >
                Refer & Earn
              </StyledText>
            </div>
            <BoxSwitch
              onLabel={"Refer Pals"}
              offLabel={"My Referals"}
              background={"#E31C79"}
              isOn={isOn}
              onToggle={toggleSwitchState}
            />
          </Header>
          <CurveHolder style={{ zIndex: 1, position: "relative" }}>
            <Curve fill={"#F2F2F2"} />
          </CurveHolder>

          <Body>
            {!isOn ? (
              <Referrals
                {...{
                  referralPoints,
                  pointsData,
                  receivedData,
                  referralData,
                  redemptions,
                  pointsEarned,
                }}
              />
            ) : (
              <Refer {...{ referralPoints, receivedData, referralData }} />
            )}
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const Refer = (data) => {
  const history = useHistory();
  const { userDetails } = useSubscriber();
  const { uniqueId } = userDetails || {};
  const textRef = useRef(null);
  const referralCode = uniqueId;

  const handleCopyClick = () => {
    const textArea = document.createElement("textarea");
    textArea.value = referralCode;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    alert("code copied");
  };

  return (
    <Box
      style={{
        display: "flex",
        backgroundColor: "transparent",
        marginTop: -35,
        flexDirection: "column",
      }}
    >
      <StyledText
        style={{ fontFamily: "MTNRegular", lineHeight: 1.4, fontSize: 14 }}
      >
        Share your dynamic link or code, score points, and snag-free data and
        shopping vouchers.
      </StyledText>
      <Box style={{ backgroundColor: "transparent", display: "flex" }}>
        <RewardedCard
          value={roundToDecimalPlace(data?.referralPoints || 0, 2)}
          label={"Referral Points"}
        />
        <RewardedCard
          value={data?.receivedData == "1050MB" ? data?.receivedData : 0}
          label={"Received Data"}
        />
      </Box>
      <ReferralCountDown receivedData={data} />

      <StyledText
        style={{
          textAlign: "center",
          color: "#7F7F7F",
          fontSize: 18,
          fontFamily: "MTNRegular",
        }}
      >
        My Referral code
      </StyledText>
      <div
        style={{
          display: "flex",
          alignSelf: "center",
          alignItems: "center",
          border: "1px dashed #E31C79",
          backgroundColor: "transparent",
          padding: "8px 50px",
          borderRadius: 8,
        }}
        onClick={() => handleCopyClick()}
      >
        <StyledText
          ref={textRef}
          style={{ margin: 5, marginRight: 8, color: "#E31C79" }}
        >
          {uniqueId}
        </StyledText>
        <Copy />
      </div>
      <Box style={{ backgroundColor: "transparent", margin: 8 }}>
        <DynamicButton
          label={"Refer a friend"}
          color={"#E31C79"}
          fullWidth
          onClick={() => {
            history.push(
              `/referral/share?message=https://mymtn.onelink.me/cB5t/PulseRefer?code=${uniqueId}`
            );
          }}
        />
        <DynamicButton
          variant="outlined"
          label={"How it works"}
          color={"#E31C79"}
          fullWidth
          onClick={() => {
            history.push("/referral/referralfaq");
          }}
        />
      </Box>
    </Box>
  );
};

const Referrals = (data) => {
  const [redemptionListState, setRedemptionListState] = useState("pending");
  const history = useHistory();
  return (
    <Box
      style={{
        display: "flex",
        backgroundColor: "transparent",
        marginTop: -35,
        flexDirection: "column",
      }}
    >
      <Box
        style={{
          backgroundColor: "transparent",
          display: "flex",
          marginBottom: 0,
        }}
      >
        <RewardedCard
          value={roundToDecimalPlace(data?.referralPoints, 2)}
          label={"Referral Points"}
        />
        <RewardedCard
          value={data?.receivedData == "1050MB" ? data?.receivedData : 0}
          label={"Received Data"}
        />
      </Box>
      <ReferralCountDown receivedData={data} />
      <Box
        style={{
          height: 1,
          margin: "50px 0px",
          backgroundColor: "#E5E5E5",
          padding: 0,
          marginTop: 15,
          marginBottom: 15,
        }}
      />
      <Box style={{ backgroundColor: "transparent", margin: 8, marginTop: 0 }}>
        <DynamicButton
          label={"Redeem points"}
          color={"#E31C79"}
          fullWidth
          onClick={() => {
            history.push("/referral/pointredemption");
          }}
        />
        <DynamicButton
          variant="outlined"
          label={"View all referrals"}
          color={"#E31C79"}
          fullWidth
          textAlign={"center"}
          endIcon={<ChevronRightArrow fill={"#E31C79"} />}
          labelCenter
          onClick={() => {
            history.push("/referral/myreferrals", {
              referrals: data?.referralData,
              pointsEarned: data?.pointsEarned,
              pointsData: data?.pointsData,
            });
          }}
        />
      </Box>
      <Box
        style={{
          height: 1,
          margin: "50px 0px",
          backgroundColor: "#E5E5E5",
          padding: 0,
          marginTop: 15,
          marginBottom: 0,
        }}
      />
      <Box style={{ backgroundColor: "transparent", marginTop: 0 }}>
        <StyledText style={{ textAlign: "left", fontSize: 22 }}>
          All Redemptions
        </StyledText>
        <RedemptionsCard
          setRedemptionListState={setRedemptionListState}
          redemptionListState={redemptionListState}
          redemptions={data?.redemptions}
        />
      </Box>
    </Box>
  );
};

const RedemptionsCard = ({
  redemptionListState,
  setRedemptionListState,
  redemptions,
}) => {
  return (
    <div
      style={{
        widt: "100%",
        boxShadow: "2px 2px #E5E5E5",
        borderRadius: 15,
        margin: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          borderTopLeftRadius: 15,
          borderTopRightRadius: 15,
          margin: 0,
        }}
      >
        <div
          style={{ flex: 1, justifyContent: "center" }}
          onClick={() => {
            setRedemptionListState("pending");
          }}
        >
          <StyledText style={{ textAlign: "center", marginBottom: 0 }}>
            Pending
          </StyledText>
          {redemptionListState === "pending" && (
            <div
              style={{
                height: 5,
                backgroundColor: "#E31C79",
                margin: "5px 20px",
                borderRadius: 10,
              }}
            />
          )}
        </div>
        <div
          style={{ flex: 1, justifyContent: "center" }}
          onClick={() => {
            setRedemptionListState("completed");
          }}
        >
          <StyledText style={{ textAlign: "center", marginBottom: 0 }}>
            Completed
          </StyledText>
          {redemptionListState === "completed" && (
            <div
              style={{
                height: 5,
                backgroundColor: "#E31C79",
                margin: "5px 20px",
                borderRadius: 10,
              }}
            />
          )}
        </div>
      </div>
      <Box
        style={{
          padding: "15px 10px",
          backgroundColor: "white",
          borderBottomLeftRadius: 15,
          borderBottomRightRadius: 15,
          margin: 0,
        }}
      >
        {redemptions
          ?.filter((redemption) => redemption?.status === redemptionListState)
          .map((redemption) => (
            <ReferralPointsItem
              key={redemption._id}
              reward={redemption.reward}
              points={redemption.pointsRedeem}
              date={redemption.createdAt}
              state={redemptionListState}
              id={redemption._id}
            />
          ))}
      </Box>
    </div>
  );
};

const RewardedCard = ({ value, label }) => (
  <Box
    style={{
      backgroundColor: "white",
      borderRadius: 20,
      height: 80,
      flex: 1,
      margin: 10,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "2px 2px #E5E5E5",
    }}
  >
    <StyledText style={{ margin: 0, fontSize: 30, color: "#E31C79" }}>
      {value}
    </StyledText>
    <StyledText style={{ margin: 0, fontFamily: "MTNRegular", fontSize: 14 }}>
      {label}
    </StyledText>
  </Box>
);

const Header = styled.div`
  overflow: hidden;
  padding: 20px 20px 80px 20px;
  background-color: ${({ background }) => background};
  position: relative;
  background-size: cover;
`;

const ReferralPointsItem = ({ reward, date, points, state, id }) => {
  const history = useHistory();
  return (
    <div
      style={{
        boxShadow: "0 5px 8px rgba(0,0,0,0.2)",
        marginBottom: "10px",
        borderRadius: "15px",
        overflow: "hidden",
        background: "#fff",
      }}
      onClick={() => {
        history.push("/referral/redemptionstatus", { id });
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{ flexGrow: 1, boxSizing: "border-box", padding: "10px 20px" }}
        >
          <StyledText
            size={13}
            style={{ fontFamily: "MTNMedium", margin: "0 0 3px 0" }}
          >
            {reward?.name}
          </StyledText>
          <StyledText style={{ fontFamily: "MTNRegular", margin: 0 }} size={11}>
            {date ? format(new Date(date), "PPP") : ""}
          </StyledText>
          {state === "pending" ? <RedemptionPending /> : <RedemptionComplete />}
        </div>
        <PointsCard>
          <StyledText style={{ margin: 0 }}> {points} pts</StyledText>
        </PointsCard>
      </div>
    </div>
  );
};

const RedemptionPending = () => (
  <div style={{ display: "flex", alignItems: "center", marginTop: 5 }}>
    <ExclamationSmall />
    <StyledText
      style={{
        fontFamily: "MTNLight",
        color: "#F5821E",
        margin: 0,
        marginLeft: 5,
      }}
      size={10}
    >
      Pending
    </StyledText>
  </div>
);

const RedemptionComplete = () => (
  <div style={{ display: "flex", alignItems: "center", marginTop: 5 }}>
    <CheckCircleIcon fill={"#0FAF4B"} />
    <StyledText
      style={{
        fontFamily: "MTNLight",
        color: "#0FAF4B",
        margin: 0,
        marginLeft: 5,
      }}
      size={10}
    >
      Completed
    </StyledText>
  </div>
);

const PointsCard = styled.div`
  width: 100px;
  box-sizing: border-box;
  padding: 30px 10px;
  color: #fff;
  font-family: MTNBold;
  background: #00678f;
  text-align: center;
`;

const NoCompletedReferralContainer = styled.div`
  height: 50vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 80px;
`;

const ReferralCountDown = ({ receivedData: { referralData } }) => {
  const referralsRemaining = 3 - parseInt(referralData?.length || 0);
  const referralPhrase = referralsRemaining < 2 ? "referral" : "referrals";
  return (
    <Box style={{ background: "none", textAlign: "center", padding: 0 }}>
      {(referralsRemaining % 3 > 0 || !referralData?.length) && (
        <StyledText
          style={{
            fontFamily: "MTNRegular",
            fontSize: "11px",
            padding: 0,
            margin: 0,
            color: "#777",
            visibility: !referralData ? "hidden" : "visible",
          }}
        >
          {referralsRemaining} {referralPhrase} remaining to get 1050MB of data
        </StyledText>
      )}
    </Box>
  );
};

export default ReferralHome;
